'use client'

import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    console.error('[ErrorBoundary]', error.message)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[200px] flex-col items-center justify-center gap-4 text-center">
          <p className="text-[var(--color-text-primary)] text-base font-medium">
            Something went wrong.
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="rounded-[var(--radius-md)] bg-[var(--color-brand-indigo)] px-4 py-2 text-sm font-medium text-white transition-[filter] hover:brightness-110"
          >
            Try again
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
